import { temporarilyNotSupport } from '../../utils'

// 设置
export const openSetting = temporarilyNotSupport('openSetting')
export const getSetting = temporarilyNotSupport('getSetting')
